---
Code from : https://dev.to/bhaskarnair2/how-to-add-an-add-to-homescreen-button-in-your-pwa-na
---

<template>
  <div>
    <button
      v-if="deferredPrompt"
      ref="addBtn"
      class="add-button"
      @click="clickCallback"
    >
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="isolation:isolate" viewBox="0 0 512 512" width="20px"><path d=" M 456 327 L 456 396 C 456 429.115 429.115 456 396 456 L 116 456 C 82.885 456 56 429.115 56 396 L 56 327 M 416 327 L 416 396 C 416 396.01 416 396.02 416 396.03 C 416 398.69 415.47 401.31 414.44 403.76 C 413.43 406.14 411.97 408.31 410.13 410.13 C 408.31 411.97 406.14 413.43 403.76 414.44 C 401.31 415.47 398.69 416 396.03 416 C 396.02 416 396.01 416 396 416 L 116 416 C 115.99 416 115.98 416 115.97 416 C 113.31 416 110.69 415.47 108.24 414.44 C 105.86 413.43 103.69 411.97 101.87 410.13 C 100.03 408.31 98.57 406.14 97.56 403.76 C 96.53 401.31 96 398.69 96 396.03 C 96 396.02 96 396.01 96 396 L 96 327" fill-rule="evenodd" fill="var(--color-2)"/><g><mask id="_mask_jFvAuRZhNz7LCJv4ZtxqKSabieG9P0KY"><line x1="56" y1="327" x2="56" y2="296" fill="white" stroke="none"/></mask><line x1="56" y1="327" x2="56" y2="296" mask="url(#_mask_jFvAuRZhNz7LCJv4ZtxqKSabieG9P0KY)" vector-effect="non-scaling-stroke" stroke-width="40" stroke="var(--color-2)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/><mask id="_mask_K9ua2TW00NSuyrnx3OmTwIF7Ev9Z4gNX"><line x1="456" y1="296" x2="456" y2="327" fill="white" stroke="none"/></mask><line x1="456" y1="296" x2="456" y2="327" mask="url(#_mask_K9ua2TW00NSuyrnx3OmTwIF7Ev9Z4gNX)" vector-effect="non-scaling-stroke" stroke-width="40" stroke="var(--color-2)" stroke-linejoin="miter" stroke-linecap="square" stroke-miterlimit="3"/></g><path d=" M 256 375.014 L 174 232.986 L 338 232.986 L 256 375.014 Z  M 230 38 L 282 38 L 282 232.986 L 230 232.986 L 230 38 Z " fill-rule="evenodd" fill="var(--color-2)"/></svg>
      Install VAPI on this device
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BtnAddToHomeScreen',
  computed: {
    ...mapGetters({
      deferredPrompt: 'deferredPrompt',
    }),
  },
  methods: {
    clickCallback() {
      // Show the prompt
      this.deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          // Call another function?
        }
        this.deferredPrompt = null;
      });
    },
  },
};
</script>

<style scoped>
button{
  display: flex;
  align-items: center;
  padding: var(--unit-2);
}

button > svg {
  margin-right: var(--unit-2);
}
</style>
